var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFavheart = function SvgFavheart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m30 53.375-3.625-3.3C13.5 38.4 5 30.7 5 21.25 5 13.55 11.05 7.5 18.75 7.5c4.35 0 8.525 2.025 11.25 5.225 2.725-3.2 6.9-5.225 11.25-5.225C48.95 7.5 55 13.55 55 21.25c0 9.45-8.5 17.15-21.375 28.85z"
  })));
};
export default SvgFavheart;